import React from 'react';
import { HorizontalDivider } from '../HorizontalDivider/HorizontalDivider';
import './GenericCard.scss';
import cls from 'classnames';

export function GenericCard({
  imageUrl,
  imageClassName,
  imageAlt,
  top,
  bottom,
  className,
}: GenericCardProps) {
  return (
    <div className={cls(className, 'mt-card')}>
      <img className={imageClassName} src={imageUrl} alt={imageAlt} />
      <div className="mt-card-content">
        {top}
        {bottom && (
          <>
            <HorizontalDivider />
            {bottom}
          </>
        )}
      </div>
    </div>
  );
}

export type GenericCardProps = {
  className?: string;
  imageUrl: string;
  imageAlt?: string;
  imageClassName?: string;
  top: React.ReactNode;
  bottom?: React.ReactNode;
};
